<template>
	<!-- Page Introduction Wrapper -->
	<div class="page-style-a">
		<div class="container">
			<div class="page-intro">
				<h2>Account</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a href="account.html">Account</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- Page Introduction Wrapper /- -->
	<!-- Account-Page -->
	<div class="page-account u-s-p-t-80" v-if="orderDetail">
		<div class="container login_container">
			<div class="row">
				<div class="col-lg-12">
					<div class="your-rating-wrapper">
						<h6 class="review-h6">
							<b
								>Your Review is matter. ({{
									orderDetail.product_combination?.product.product_name
								}})</b
							>
						</h6>
						<h6
							class="text-muted"
							v-for="av in orderDetail.product_combination?.attribute_variations"
							:key="av.id"
						>
							{{ av.attribute.name }} - {{ av.variation.name }}
						</h6>
						<div class="star-wrapper u-s-m-b-8">
							<div class="d-flex">
								<StarRating
									:increment="1"
									:star-size="25"
									:read-only="false"
									:show-rating="false"
									v-model:rating="rating"
								/>
							</div>
						</div>
						<form @submit.prevent="submitReview">
							<label for="review-title"
								>Review Title
								<span class="astk"> *</span>
							</label>
							<input
								id="review-title"
								type="text"
								class="text-field"
								placeholder="Review Title"
								v-model="review_title"
								required
							/>
							<label for="review-text-area"
								>Review
								<span class="astk"> *</span>
							</label>
							<textarea
								class="text-area u-s-m-b-8"
								id="review-text-area"
								placeholder="Review"
								v-model="review"
								required
							></textarea>
							<button class="button button-outline-secondary" :disabled="loading">
								{{ loading ? "Please Wait.." : "Submit Review" }}
							</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- Account-Page /- -->

	<Footer />
</template>

<script>
	import Login from "../components/Auth/Login.vue";
	import Register from "../components/Auth/Register.vue";
	import Footer from "../components/Bottom/Footer.vue";
	import StarRating from "vue-star-rating";
	import axios from "axios";
	export default {
		components: {Login, Register, Footer, StarRating},
		props: ["orderDetails"],
		data() {
			return {
				rating: 1,
				review_title: "",
				review: "",
				loading: false,
				editMode: false,
				review_id: "",
				orderDetail: this.orderDetails ? JSON.parse(this.orderDetails) : null, //check if orderDetails from props is null
			};
		},
		methods: {
			scroll() {
				const el = document.getElementsByClassName("page-style-a")[0];
				this.$smoothScroll({
					scrollTo: el, // scrollTo is also allowed to be number
				});
			},
			async submitReview() {
				this.loading = true;
				let url = this.editMode
					? `${process.env.VUE_APP_API_URL}/api/frontend/product-reviews/${this.review_id}`
					: process.env.VUE_APP_API_URL + "/api/frontend/product-reviews";
				let postData = {
					review: this.review,
					review_title: this.review_title,
					rating: this.rating,
					// order_id: this.orderDetail.order_id,
					order_detail_id: this.orderDetail.id,
					product_combination_id: this.orderDetail.product_combination_id,
					// warehouse_id: 1,
					status: "active",
				};
				let token = localStorage.getItem("token");
				try {
					// send post request
					let {data} = await axios({
						method: this.editMode ? "put" : "post",
						url,
						data: postData,
						headers: {
							Authorization: `Bearer ${token}`,
						},
					});
					console.log(data);
					this.$router.push({name: "Orders"});
					this.loading = false;
				} catch (error) {
					console.log(error);
					this.loading = false;
				}
			},
		},
		mounted() {
			console.log("Add Review Mounted");
			this.scroll();
			if (!this.orderDetail) {
				// redirect to home page
				this.$router.push({name: "Home"});
				return;
			}
			if (this.orderDetail.review) {
				this.editMode = true;
				this.review_title = this.orderDetail.review.review_title;
				this.review = this.orderDetail.review.review;
				this.rating = parseInt(this.orderDetail.review.rating);
				this.review_id = this.orderDetail.review.id;
			}
		},
	};
</script>

<style></style>
